import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins'
import store from './store'
import './util/string.prototypes.js'
import { sync } from 'vuex-router-sync'
// eslint-disable-next-line import/no-named-default
// import { VeeValidate } from 'vee-validate'
import InputMoney from '@/components/InputMoney'
Vue.config.productionTip = false

// Vue.use(VeeValidate)

sync(store, router)
Vue.component('v-text-money', InputMoney)
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App),
}).$mount('#app')
